import { DeviceOs, DeviceType, EmailPriority, HolidayRequestStatus, HolidayTime, MessageSendingStatus, PlayerPosition, PlayerStatus, UserSignupMethod, UserStatus, VisitorType } from "src/app/enums/Index";
import { EnumMap } from "src/app/interfaces/Index";
import { ResourceType } from "../enums/ResourceType";

export function GetPropertiesFromEnum(enumName: typeof DeviceOs | typeof DeviceType | typeof HolidayRequestStatus | typeof HolidayTime | typeof EmailPriority | typeof MessageSendingStatus | typeof PlayerPosition | typeof PlayerStatus | typeof ResourceType | typeof UserSignupMethod | typeof UserStatus | typeof VisitorType): EnumMap[] {
	const arrayObjects: EnumMap[] = [];  
	for (const [propertyKey, propertyValue] of Object.entries(enumName)) {
		if (!Number.isNaN(Number(propertyKey))) continue;
		const name = propertyKey.replace(/(\B[A-Z])/g, " $1").replace(/(\B[0-9]+)/g, " $1")
		arrayObjects.push(new EnumMap({id: (propertyValue as number), name: name.charAt(0).toUpperCase() + name.slice(1)}));
	}
	return arrayObjects;
}